import i18n from './i18n';

const localizedTextsMap = {
  actions: i18n.t('actions'),
  and: i18n.t('and'),
  cancel: i18n.t('cancel'),
  changeFilterMode: i18n.t('changeFilterMode'),
  changeSearchMode: i18n.t('changeSearchMode'),
  clearFilter: i18n.t('clearFilter'),
  clearSearch: i18n.t('clearSearch'),
  clearSelection: i18n.t('clearSelection'),
  clearSort: i18n.t('clearSort'),
  clickToCopy: i18n.t('clickToCopy'),
  copy: i18n.t('copy'),
  collapse: i18n.t('collapse'),
  collapseAll: i18n.t('collapseAll'),
  columnActions: i18n.t('columnActions'),
  copiedToClipboard: i18n.t('copiedToClipboard'),
  dropToGroupBy: i18n.t('dropToGroupBy'),
  edit: i18n.t('edit'),
  expand: i18n.t('expand'),
  expandAll: i18n.t('expandAll'),
  filterArrIncludes: i18n.t('filterArrIncludes'),
  filterArrIncludesAll: i18n.t('filterArrIncludesAll'),
  filterArrIncludesSome: i18n.t('filterArrIncludesSome'),
  filterBetween: i18n.t('filterBetween'),
  filterBetweenInclusive: i18n.t('filterBetweenInclusive'),
  filterByColumn: i18n.t('filterByColumn'),
  filterContains: i18n.t('filterContains'),
  filterEmpty: i18n.t('filterEmpty'),
  filterEndsWith: i18n.t('filterEndsWith'),
  filterEquals: i18n.t('filterEquals'),
  filterEqualsString: i18n.t('filterEqualsString'),
  filterFuzzy: i18n.t('filterFuzzy'),
  filterGreaterThan: i18n.t('filterGreaterThan'),
  filterGreaterThanOrEqualTo: i18n.t('filterGreaterThanOrEqualTo'),
  filterInNumberRange: i18n.t('filterInNumberRange'),
  filterIncludesString: i18n.t('filterIncludesString'),
  filterIncludesStringSensitive: i18n.t('filterIncludesStringSensitive'),
  filterLessThan: i18n.t('filterLessThan'),
  filterLessThanOrEqualTo: i18n.t('filterLessThanOrEqualTo'),
  filterMode: i18n.t('filterMode'),
  filterNotEmpty: i18n.t('filterNotEmpty'),
  filterNotEquals: i18n.t('filterNotEquals'),
  filterStartsWith: i18n.t('filterStartsWith'),
  filterWeakEquals: i18n.t('filterWeakEquals'),
  filteringByColumn: i18n.t('filteringByColumn'),
  goToFirstPage: i18n.t('goToFirstPage'),
  goToLastPage: i18n.t('goToLastPage'),
  goToNextPage: i18n.t('goToNextPage'),
  goToPreviousPage: i18n.t('goToPreviousPage'),
  grab: i18n.t('grab'),
  groupByColumn: i18n.t('groupByColumn'),
  groupedBy: i18n.t('groupedBy'),
  hideAll: i18n.t('hideAll'),
  hideColumn: i18n.t('hideColumn'),
  max: i18n.t('max'),
  min: i18n.t('min'),
  move: i18n.t('move'),
  noRecordsToDisplay: i18n.t('noRecordsToDisplay'),
  noResultsFound: i18n.t('noResultsFound'),
  of: i18n.t('of'),
  or: i18n.t('or'),
  pin: i18n.t('pin'),
  pinToLeft: i18n.t('pinToLeft'),
  pinToRight: i18n.t('pinToRight'),
  resetColumnSize: i18n.t('resetColumnSize'),
  resetOrder: i18n.t('resetOrder'),
  rowActions: i18n.t('rowActions'),
  rowNumber: i18n.t('rowNumber'),
  rowNumbers: i18n.t('rowNumbers'),
  rowsPerPage: i18n.t('rowsperpage'),
  save: i18n.t('save'),
  search: i18n.t('search'),
  selectedCountOfRowCountRowsSelected: i18n.t('selectedCountOfRowCountRowsSelected'),
  select: i18n.t('select'),
  showAll: i18n.t('showAll'),
  showAllColumns: i18n.t('showAllColumns'),
  showHideColumns: i18n.t('showHideColumns'),
  showHideFilters: i18n.t('showHideFilters'),
  showHideSearch: i18n.t('showHideSearch'),
  sortByColumnAsc: i18n.t('sortByColumnAsc'),
  sortByColumnDesc: i18n.t('sortByColumnDesc'),
  sortedByColumnAsc: i18n.t('sortedByColumnAsc'),
  sortedByColumnDesc: i18n.t('sortedByColumnDesc'),
  thenBy: i18n.t('thenBy'),
  toggleDensity: i18n.t('toggleDensity'),
  toggleFullScreen: i18n.t('toggleFullScreen'),
  toggleSelectAll: i18n.t('toggleSelectAll'),
  toggleSelectRow: i18n.t('toggleSelectRow'),
  toggleVisibility: i18n.t('toggleVisibility'),
  ungroupByColumn: i18n.t('ungroupByColumn'),
  unpin: i18n.t('unpin'),
  unpinAll: i18n.t('unpinAll')
};

export default localizedTextsMap;